export const FIRST_COL_WIDTH = 400
export const OTHER_COLS_WIDTH = `15%`
export const ROLES_TO_DISPLAY = window.innerWidth < 1200 ? 4 : 5
